import { render, staticRenderFns } from "./ibms.vue?vue&type=template&id=5257106a&scoped=true&"
import script from "./ibms.vue?vue&type=script&lang=js&"
export * from "./ibms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257106a",
  null
  
)

export default component.exports